import { Component, Input, OnInit } from '@angular/core';

import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import * as moment from 'moment';

import { Subject } from 'rxjs';
import { CustomerMembership } from '../../../../../../../../../models/membership';
import { CustomerMembershipStatus, MembershipPurchaseType } from '../../../../../../../../../models/membership-enums';

enum ActionList {
  cancel,
  freezeImmediately,
  unfreeze,
  editStartDate,
  editDaysRemaining,
  editAddOns,
  reassign,
  editMembers
}

@Component({
  selector: 'app-edit-prepaid-customer-membership',
  templateUrl: './edit-non-recurring-customer-membership-modal.component.html',
  styleUrls: ['./edit-non-recurring-customer-membership-modal.component.css']
})
export class EditNonRecurringCustomerMembershipModalComponent implements OnInit {

  @Input() membership: CustomerMembership;
  @Input() savedCallback: (successMessage: string) => undefined;

  public selectedAction: ActionList = null;

  public saveClickedSubject = new Subject<void>();
  public loading = false;
  public serverError: number = null;

  public ActionList = ActionList;

  constructor(
    public activeModal: NgbActiveModal
  ) {}

  ngOnInit() {
  }

  /**
   * Whether any action at all is offered for this membership. An ended
   * membership may have none, in which case the modal explains that instead
   * of showing an empty action list (PRO-1500).
   */
  public hasAvailableActions(): boolean {
    return Object.values(ActionList)
      .filter((action): action is ActionList => typeof action === 'number')
      .some((action) => this.actionIsAvailable(action));
  }

  public actionIsAvailable(action: ActionList) {
    switch (action) {
      case ActionList.cancel:
        return ![
          CustomerMembershipStatus.deniedStaffApproval,
          CustomerMembershipStatus.ended,
          CustomerMembershipStatus.awaitingInitialPayment
        ].includes(this.membership.status);
      case ActionList.freezeImmediately:
        return (
          (this.membership.purchase_type !== MembershipPurchaseType.benefit) &&
          [
            CustomerMembershipStatus.active,
            CustomerMembershipStatus.initialPaymentProcessing,
            CustomerMembershipStatus.initialPaymentProcessing
          ].includes(this.membership.status)
        );
      case ActionList.unfreeze:
        return [
          CustomerMembershipStatus.frozen,
          CustomerMembershipStatus.freezePaymentProcessing
        ].includes(this.membership.status)
      case ActionList.editStartDate:
        // Start date may be edited if the membership started at most 28 days
        // ago and has not ended (PRO-1500).
        return (
          (this.membership.purchase_type !== MembershipPurchaseType.benefit) &&
          ![
            CustomerMembershipStatus.deniedStaffApproval,
            CustomerMembershipStatus.ended
          ].includes(this.membership.status) &&
          (
            moment(this.membership.start_date) >=
            moment().startOf('day').subtract(28, 'days')
          )
        );
      case ActionList.editDaysRemaining:
        return (
          (this.membership.purchase_type !== MembershipPurchaseType.benefit) &&
          [
            CustomerMembershipStatus.active,
            CustomerMembershipStatus.initialPaymentProcessing,
            CustomerMembershipStatus.frozen,
            CustomerMembershipStatus.freezePaymentProcessing
          ].includes(this.membership.status)
      );
      case ActionList.editAddOns:
        return (
          ![
            CustomerMembershipStatus.deniedStaffApproval,
            CustomerMembershipStatus.ended
          ].includes(this.membership.status) &&
          this.membership.customer_add_on_options.length > 0
        );
      case ActionList.reassign:
        return (
          (this.membership.purchase_type !== MembershipPurchaseType.benefit) &&
          ![
            CustomerMembershipStatus.deniedStaffApproval,
            CustomerMembershipStatus.ended
          ].includes(this.membership.status) &&
          !this.membership.is_group &&
          (this.membership.unlinked_customers.length === 0)
        );
      case ActionList.editMembers:
        return (
          ![
            CustomerMembershipStatus.deniedStaffApproval,
            CustomerMembershipStatus.ended
          ].includes(this.membership.status) &&
          this.membership.is_group
        );
    }
  }

  public handleSave() {
    this.saveClickedSubject.next();
  }

}
